export default __webpack_public_path__ + "static/media/proxmox_logo.26c0090c.png";